import { memo, useCallback, useState } from "react"

import { FaPaperPlane, FaPencilAlt, FaTrashAlt } from "react-icons/fa"

import NotificationContactEditModal from "./NotificationEditModal"
import NotificationContactData from "../../../api/Randoms/Notification/NotificationContactData"
import { useNotificationContacts } from "../../../api/Randoms/Notification/useNotificationContacts"
import { useNotificationContactsActions } from "../../../api/Randoms/Notification/useNotificationContactsActions"
import ActionIconButton from "../../ActionIconButton"
import ConfirmationModal from "../../ConfirmationModal"

interface NotificationActionCellProps {
  contact: NotificationContactData
}

function NotificationActionCell({ contact }: NotificationActionCellProps) {
  const { ContactID, FirstName, LastName, NotificationMethods } = contact
  const { poolId, deletingContacts, sendingNotifications } = useNotificationContacts()
  const { deleteContacts, sendNotifications } = useNotificationContactsActions()
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)
  const [showNotificationConfirmation, setShowNotificationConfirmation] = useState(false)
  const [showContactForm, setShowContactForm] = useState(false)

  const handleDelete = useCallback(() => {
    deleteContacts(poolId, [contact])
    setShowDeleteConfirmation(false)
  }, [contact, deleteContacts, poolId])

  const handleSend = useCallback(() => {
    sendNotifications(poolId, [contact])
    setShowNotificationConfirmation(false)
  }, [contact, poolId, sendNotifications])

  if (!contact) return null

  return (
    <>
      <ActionIconButton variant="link" onClick={() => setShowContactForm(true)} className="px-1 py-0" disableOnSpin>
        <FaPencilAlt title="Edit contact." />
      </ActionIconButton>
      <ActionIconButton
        variant="link"
        onClick={() => setShowDeleteConfirmation(true)}
        className="px-1 py-0"
        spin={deletingContacts[ContactID]}
        disableOnSpin
      >
        <FaTrashAlt title="Delete contact." />
      </ActionIconButton>
      <ActionIconButton
        variant="link"
        onClick={() => setShowNotificationConfirmation(true)}
        className="px-1 py-0"
        spin={sendingNotifications[ContactID]}
        disableOnSpin
        disabled={(NotificationMethods?.length ?? 0) === 0}
      >
        <FaPaperPlane title="Send notification." />
      </ActionIconButton>

      <ConfirmationModal
        show={showDeleteConfirmation}
        title="CONFIRM REMOVE CONTACTS"
        textTitle={`Are you sure you want to remove \n${FirstName} ${LastName} contact ?`}
        onConfirm={handleDelete}
        onHide={() => setShowDeleteConfirmation(false)}
      />

      <ConfirmationModal
        show={showNotificationConfirmation}
        title="CONFIRM SENDING NOTIFICATIONS"
        textTitle={`Are you sure you want to send notifications to contact \n${FirstName} ${LastName} ?`}
        onConfirm={handleSend}
        onHide={() => setShowNotificationConfirmation(false)}
      />

      {showContactForm && <NotificationContactEditModal contact={contact} onHide={() => setShowContactForm(false)} />}
    </>
  )
}

export default memo(NotificationActionCell)
